$(document).ready(function () {
    $(".searchform").on("submit", function (e) {
        e.preventDefault();
        $(".js-search").addClass("loading");
        $(".search_preview_result").html("");

        var form = $(this);
        var action = form.data("action");
        var datas = form.serialize();
        openSearch();

        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: action,
                data: datas,
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data);
                //console.log("On cherche : " + obj.datas);
                $(".js-search").removeClass("loading");
                $(".search_preview_result").html(obj.response);
            },
            error: function (errorThrown) {
                console.log(form.data("merror"));
            },
        });
    });
});

const increaseSearch = document.querySelector(".js-increase-search-input");
const menuToggleHide = document.querySelector(".js-hide-open-search");
const searchContainer = document.querySelector(".js-search-container");
const searchInput = document.querySelector(".js-search-input");

increaseSearch.addEventListener("click", () => {
    if (searchContainer.classList.contains("is-open")) {
        searchContainer.classList.remove("is-open");
        // menuToggleHide.classList.remove('is-hidden');
        closeSearch();
    } else {
        searchContainer.classList.add("is-open");
        // menuToggleHide.classList.add('is-hidden');
        searchInput.focus();
    }
});

const searchLink = document.querySelector(".js-search-link");
const searchLinkInput = document.querySelector(".js-search-link-input");

searchLink.addEventListener("click", (e) => {
    e.preventDefault();
    //console.log(searchLinkInput.value);
    window.location.assign(
        window.location.origin + "/?s=" + searchLinkInput.value
    );
});
